import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "promo" }

import { computed, watch } from 'vue';
import { useStore } from 'vuex';
import usePromoModal from './composables/promoModalState';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
store.dispatch('platform/checkPlatform');

const isDesktop = computed(() => store.getters['platform/isDesktop']);
const isMobile = computed(() => store.getters['platform/isMobile']);
const isTablet = computed(() => store.getters['platform/isTablet']);
const isPortraitOrientation = computed(
  () => store.getters['platform/isPortraitOrientation']
);

const { show } = usePromoModal();

const getBodyClass = computed(() => {
  const bodyClass: string[] = [];

  if (isDesktop.value) {
    bodyClass.push('isDesktop');
  } else if (isTablet.value) {
    bodyClass.push('isTablet');
  } else if (isMobile.value) {
    bodyClass.push('isMobile');
  }

  if (show.value) {
    bodyClass.push('stop-scroll');
  }

  bodyClass.push(isPortraitOrientation.value ? 'isPortrait' : 'isAlbum');

  return bodyClass.join(' ');
});

watch(
  getBodyClass,
  (classes) => {
    const classesArr = [
      'isDesktop',
      'isTablet',
      'isMobile',
      'isPortrait',
      'isAlbum',
      'stop-scroll',
    ];
    classesArr.forEach((cl) => {
      document.body.classList.remove(cl);
    });
    classes.split(' ').forEach((cl) => {
      if (!document.body.classList.contains(cl)) {
        document.body.classList.add(cl);
      }
    });
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view)
  ]))
}
}

})